import React, { useEffect, useState } from "react";
import { PageHeader, Toast } from "@/components/Layout";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { lock } from "@/lib/perm";
import ViewOnly from "@/components/ViewOnly";

export default function PersonnelCategories() {
  const { has } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [msg, setMsg] = useState({ text: "", type: "info" });

  useEffect(() => { api.get("/config").then(r => setCfg(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/config", cfg);
      setMsg({ text: "Salvat", type: "success" }); setTimeout(()=>setMsg({text:""}),1500);
    } catch(e) { setMsg({ text: e?.response?.data?.detail || "Eroare", type: "error" }); }
  };
  if (!cfg) return <div>Se încarcă...</div>;

  const updCat = (i,v) => { const a = [...(cfg.personnel_categories||[])]; a[i] = v; setCfg({...cfg, personnel_categories: a}); };
  const addCat = () => setCfg({...cfg, personnel_categories: [...(cfg.personnel_categories||[]), "Categorie nouă"]});
  const rmCat = (i) => { const a = [...(cfg.personnel_categories||[])]; a.splice(i,1); setCfg({...cfg, personnel_categories: a}); };

  return (
    <>
      <PageHeader title="Categorii de personal" subtitle="Folosite la Rapoarte de muncă"
        actions={<button className="btn btn-primary" onClick={save} data-testid="save-categories" {...lock(has("config.update"))}>Salvează</button>} />
      <Toast msg={msg.text} type={msg.type} />
      <div className="card" style={{ padding: 24 }}>
        <ViewOnly on={!has("config.update")}>
        <div style={{display:"grid",gap:8}}>
          {(cfg.personnel_categories||[]).map((c,i)=>(
            <div key={i} style={{display:"flex",gap:8}}>
              <input className="input" value={c} onChange={e=>updCat(i,e.target.value)} />
              <button className="btn btn-danger" style={{padding:"4px 10px",fontSize:12}} onClick={()=>rmCat(i)}>Șterge</button>
            </div>
          ))}
          <button className="btn btn-secondary" onClick={addCat}>+ Adaugă categorie</button>
        </div>
        </ViewOnly>
      </div>
    </>
  );
}
